import Card from "@mui/material/Card";
import { Grid, Tooltip, Badge } from "@mui/material";
import { useState } from "react";
import { TrackerRelationshipsService } from "../../services/trackerRelationships";
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import eggs from "../../assets/egg.png";
import chicken from "../../assets/chick.png";
import embryo from "../../assets/embriao.png";
import no_image from "../../assets/sem_imagem.png";
import styles from "./vehicleCard.module.scss";
import { DetailsModal } from "./detaislModal";
import { SensorsChartModal } from "./sensorsChartModal";
import { AlarmsModal } from "./alarmsModal";
import { MapModal } from "./mapModal";
import { VehicleStateIcons } from "./vehicleStateIcons";
import { OccurrenceModal } from "./occurrenceModal";
import { Button, Typography } from "antd";

export const VehicleCard = ({
  nonMonitored,
  cardType,
  vehicle,
  stopUpdateKanban,
}) => {
  const [sensorSelectedToChart, setSensorSelectedToChart] = useState("");
  const [vehicleDetails, setVehicleDetails] = useState({});
  const [sensorDataToChart, setSensorDataToChart] = useState([]);
  const [open, setOpen] = useState(false);
  const [openModalSensorChart, setOpenModalSensorChart] = useState(false);
  const [openModalOccurrence, setOpenModalOccurrence] = useState(false);
  const [openModalAlarms, setOpenModalAlarms] = useState(false);
  const [openModalMap, setOpenModalMap] = useState(false);
  const [vehicleSelected, setVehicleSelected] = useState();
  const [disableButton, setDisableButton] = useState(false);
  const [isOperationInProgress, setIsOperationInProgress] = useState(false);
  const [latlng, setLatLng] = useState();

  const trackerRelationshipsService = new TrackerRelationshipsService();
  const TIME_UPDATE_INFO_DETAILS_CARD = 60000;
  const [vehicleDetailsTimer, setVehicleDetailsTimer] = useState();
  const [latLongTimer, setLatLongTimer] = useState();



  const getVehicleDetails = (trackerRelationshipId, attempt = 1) => {
    trackerRelationshipsService
      .getVehicleDetails(trackerRelationshipId)
      .then((res) => {
        setVehicleDetails(res.data);
        setOpen(true);
      })
      .catch((error) => {
        console.error(error);
        setDisableButton(false);
      });
  };

  const handleDetailsClick = (e) => {
    e.preventDefault();
    if (disableButton) {
      return;
    }

    setDisableButton(true);
    const vehicleSelected = vehicle.trackerRelationshipId;
    setVehicleSelected(vehicleSelected);
    getVehicleDetails(vehicleSelected);
    if (stopUpdateKanban) {
      clearInterval(sessionStorage.getItem("updateKanban"));
      sessionStorage.removeItem("updateKanban");
    }
    const id_updateDetails = setInterval(() => {
      getVehicleDetails(vehicleSelected);
    }, TIME_UPDATE_INFO_DETAILS_CARD);
    setVehicleDetailsTimer(id_updateDetails);
    sessionStorage.setItem("id_interval_sensorChart", id_updateDetails);
  };

  const handleCloseDetailsModal = () => {
    setIsOperationInProgress(false);
    setOpen(false);
    setDisableButton(false);
    sessionStorage.removeItem("id_interval_sensorChart");
    setVehicleDetailsTimer(clearInterval(vehicleDetailsTimer));
  };

  const handleOpenSensorsChartModal = () => {
    setOpenModalSensorChart(true);
  };

  const handleOpenOccurrenceModal = () => {
    setOpenModalOccurrence(true);
  };

  const handleSensorSelectedToChart = (sensor) => {
    setSensorSelectedToChart(sensor);
  };

  const handleSensorDataToChart = (sensorData) => {
    setSensorDataToChart(sensorData);
  };

  const handleOnCloseSensorsChartModal = () => {
    const id_interval_sensorChart = sessionStorage.getItem(
      "id_interval_sensorChart"
    );
    clearInterval(id_interval_sensorChart);
    sessionStorage.removeItem("id_interval_sensorChart");
    setOpenModalSensorChart(false);
    setSensorDataToChart([]);
  };

  const handleOnCloseOccurrenceModal = () => {
    setOpenModalOccurrence(false);
  };

  const handleOpenModalMap = () => {
    setOpenModalMap(true);
    setLatLng({ lat: parseFloat(vehicle.latitude), lng: parseFloat(vehicle.longitude) })
  };

  const handleOnCloseMapModal = () => {
    setOpenModalMap(false);
    setLatLongTimer(clearInterval(latLongTimer));
  };

  const handleOpenModalAlarms = () => {
    setOpenModalAlarms(true);
  };

  const handleOnCloseAlarmsModal = () => {
    setOpenModalAlarms(false);
  };

  return (
    <div>
      <Card
        className={`${styles.cardVehicle} ${cardType === "inOrigin"
          ? styles.cardInOrigin
          : cardType === "inRoute"
            ? styles.cardInRoute
            : cardType === "notMonitorated"
              ? styles.cardNotMonitorated
              : styles.cardFinished
          }`}

      >
        <Grid container style={{ display: "flex", alignItems: "center" }}>
          <Grid
            item
            xs={2}
            style={{ display: "flex", justifyContent: "center" }}
          >
            <Tooltip
              title={vehicle.typeOperation === "OVOS" ? "Ovos" : vehicle.typeOperation === "PINTOS" ? "Pintinhos" :
                vehicle.typeOperation === "EMBRIÕES" ? "Embriões" : ""
              }
              placement="top"
            >
              {(() => {
                switch (vehicle.typeOperation) {
                  case "OVOS":
                    return (
                      <img
                        src={eggs}
                        alt="Ícone"
                        style={{
                          width: "30px",
                          height: "30px",
                        }}
                      />
                    );
                  case "PINTOS":
                    return (
                      <img
                        src={chicken}
                        alt="Ícone"
                        style={{
                          width: "40px",
                          height: "40px",
                        }}
                      />
                    );
                  case "EMBRIÕES":
                    return (
                      <img
                        src={embryo}
                        alt="Ícone"
                        style={{
                          width: "30px",
                          height: "30px",
                        }}
                      />
                    );
                  default:
                    return (
                      <img
                        src={no_image}
                        alt="Ícone"
                        style={{
                          width: "40px",
                          height: "40px",
                        }}
                      />
                    );
                  // outros casos
                }
              })()}
            </Tooltip>
          </Grid>
          <Grid
            item
            xs={8}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              alignContent: "center",
              justifyContent: "center",
            }}
          >
            <div className={styles.plateName}>
              <Tooltip title="Placa">
                <Typography style={{ fontSize: vehicle.vehiclePlate.length > 7 ? "18px" : "24px", padding: "0px" }}>
                  {vehicle.vehiclePlate}
                </Typography>
              </Tooltip>
            </div>
            <div className={styles.driverName}>
              <Tooltip title="Motorista">
                <Typography style={{ fontSize: "11px" }}>
                  {vehicle.driverName === ""
                    ? "Sem Motorista"
                    : vehicle.driverName}
                </Typography>
              </Tooltip>
            </div>
          </Grid>
          <Grid item xs={2} className={styles.alarmsIcon}>
            <Tooltip title="Alarmes Disparados" placement="top">
              <Badge
                color={'error'}
                showZero
                badgeContent={vehicle.numberOfEvents}
                max={99}
              >
                <NotificationsRoundedIcon
                  className={styles.iconNoPulse}
                >
                </NotificationsRoundedIcon>
              </Badge>
            </Tooltip>
          </Grid>

          <Grid
            item
            xl={8}
            lg={8}
            md={12}
            sm={12}
            xs={8}

          >
            <VehicleStateIcons
              numberOfEvents={vehicle.numberOfEvents}
              driverAwareness={vehicle.isDriverAware}
              ignition={vehicle.ignition}
              speed={vehicle.vehicleSpeed}
              thermoKing={vehicle.thermoKing}
              isAlarmActived={vehicle.isAlarmActived}
              door={vehicle.isDoorOpen}
            />
          </Grid>
          <Grid item xl={4} lg={4} md={12} sm={12} xs={4} style={{ marginTop: "-5px" }}>
            <Tooltip title="Ver Detalhes">
              <Button
                type="primary"
                className={styles.detailsButton}
                disabled={disableButton}
                onClick={(e) => {
                  handleDetailsClick(e);
                }}
              >
                DETALHES
              </Button>
            </Tooltip>
          </Grid>
        </Grid>
      </Card>
      <DetailsModal
        open={open}
        nonMonitored={nonMonitored}
        handleOnClose={handleCloseDetailsModal}
        vehicleDetails={vehicleDetails}
        setSensorSelectedToChart={handleSensorSelectedToChart}
        setSensorDataToChart={handleSensorDataToChart}
        openSensorsChartModal={handleOpenSensorsChartModal}
        openOccurrenceModal={handleOpenOccurrenceModal}
        openModalAlarms={handleOpenModalAlarms}
        openModalMap={handleOpenModalMap}
        vehicleDetailsTimer={vehicleDetailsTimer}
      />

      <MapModal
        open={openModalMap}
        handleOnClose={handleOnCloseMapModal}
        latlng={latlng}
        updatedAt={vehicleDetails.lastUpdate}
        vehicleSelected={vehicleSelected}
      />

      <SensorsChartModal
        open={openModalSensorChart}
        handleOnClose={handleOnCloseSensorsChartModal}
        sensor={sensorSelectedToChart}
        dataToChart={sensorDataToChart}
      />
      <OccurrenceModal
        open={openModalOccurrence}
        handleOnClose={handleOnCloseOccurrenceModal}
        vehicleDetails={vehicleDetails}
      />
      {openModalAlarms ? (
        <AlarmsModal
          open={openModalAlarms}
          handleOnClose={handleOnCloseAlarmsModal}
          vehicleSelected={vehicleSelected}
        />
      ) : (
        <></>
      )}
    </div>
  );
};
